export default __webpack_public_path__ + "static/media/O Sistema Exu-Ogum.0aa54efb.pdf";